module.exports = __webpack_public_path__ + "static/media/technology.08594ae2.png";